import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { ConnectionService } from 'src/app/shared-services/connection.service';
import { environment } from 'src/environments/environment';
import { ApplicationBusinessInfo } from '../application.business.info';
import { ApplicationOwnerItem } from '../application.owner.item';

declare var $: any;

@Component({
    selector: 'app-co-signer-information',
    templateUrl: './co-signer-information.component.html',
    styleUrls: ['../application.component.css', './co-signer-information.component.css']
})
export class CoSignerInformationComponent implements OnInit {
    @Input() token: any;
    @Input() statesIssued: any[] = [];
    @Input() ownershipPercentage: number = 0;
    @Input() appInfo: ApplicationBusinessInfo;
    @Output() ownerItem = new EventEmitter<any>();

    coSignerInfo: ApplicationOwnerItem = new ApplicationOwnerItem(this.formBuilder);
    cities: any[] = [];
    states: any[] = [];
    errorTitle = '';
    errorMessageA = '';
    errorMessageB = '';
    errorMessageC = '';
    errorMessageBClass = '';
    errorId = 'OwnPercentageE';
    submitted = false;
    production: boolean = environment.production;
    today = new Date();
    maxAgeDate = new Date((new Date()).setFullYear(new Date().getFullYear() - 18));

    get coSignerForm() { return this.coSignerInfo.form.controls; }

    constructor(
        private formBuilder: FormBuilder,
        private connectionService: ConnectionService
    ) { }

    ngOnInit(): void {
        this.coSignerForm.sameAsBusiness.setValue(false);
        this.coSignerForm.creditAuth.setValue(false);
        this.coSignerForm.creditAuthTwo.setValue(false);
    }

    onSubmit(): void {
        this.submitted = true;

        if (this.coSignerInfo.form.invalid) {
            return;
        }

        this.ownerItem.emit(this.coSignerInfo.form);

        $('#coSignerModal').modal("hide");

        this.submitted = false;
        this.coSignerInfo = new ApplicationOwnerItem(this.formBuilder);

        Object.keys(this.coSignerForm).forEach((key: any) => {
            this.coSignerForm[key].markAsUntouched();
            this.coSignerForm[key].clearValidators();
            this.coSignerForm[key].updateValueAndValidity();
            this.coSignerForm[key].reset();
        });
    }

    onZipCodeKeyUp(owner: any) {
        return new Promise((resolve, reject) => {
            this.getZipCodeData(owner.zipCode.value).then(
                (data: any) => {
                    if (data.object) {
                        this.cities = data.object.city;
                        this.states = this.statesIssued;
                        this.coSignerForm.state.setValue(data.object.state);
                        this.coSignerForm.city.setValue(data.object.city[0]);
                        resolve(data);
                    } else {
                        this.cities = [];
                        this.coSignerForm.city.setValue('');
                        reject();
                    }
                },
                (error: any) => {
                    this.cities = [];
                    this.states = [];
                    owner.state.setValue('');
                    reject();
                }
            );
        });
    }

    onZipCodeKeyUpHandler(owner: any) {
        this.onZipCodeKeyUp(owner).then(
            () => { void (0); },
            () => { void (0); }
        );
    }

    getZipCodeData(zipCode: string) {
        return new Promise((resolve, reject) => {
            if (this.token) {
                this.connectionService.getRequestWithToken(`${environment.gateway}applicationNl/zipData/${zipCode}`, 'application/json', this.token).subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
            } else {
                this.connectionService.getRequest(`${environment.gateway}application/zipData/${zipCode}`, 'application/json').subscribe(
                    (data: any) => {
                        resolve(data);
                    },
                    (error: any) => {
                        reject(error);
                    }
                );
            }
        });
    }

    onSetSameBusiness() {
        const appInfo = this.appInfo.form.controls;

        if (this.coSignerForm.sameAsBusiness) {
            this.coSignerForm.zipCode.setValue(appInfo.zip.value)
            this.coSignerForm.city.setValue(appInfo.city.value)
            this.coSignerForm.homeAddress.setValue(appInfo.businessAddress.value)
            this.coSignerForm.state.setValue(appInfo.state.value)
            this.onZipCodeKeyUp(this.coSignerForm);
        }
        this.disableInputsBusiness();
    }

    onCompleteInformationClick() {
        this.coSignerInfo.setDefaultData(1);

        this.onZipCodeKeyUp(this.coSignerForm).then(() => {
            this.coSignerInfo.setDefaultData(1);
        });
        this.coSignerInfo.form.controls.authorize.setValue('true');
    }

    closeDialog() {
        this.submitted = false;
        this.coSignerInfo = new ApplicationOwnerItem(this.formBuilder);
    }

    private disableInputsBusiness() {
        this.coSignerForm.city.enabled ? this.coSignerForm.city.disable() : this.coSignerForm.city.enable();
        this.coSignerForm.zipCode.enabled ? this.coSignerForm.zipCode.disable() : this.coSignerForm.zipCode.enable();
        this.coSignerForm.homeAddress.enabled ? this.coSignerForm.homeAddress.disable() : this.coSignerForm.homeAddress.enable();
        this.coSignerForm.state.enabled ? this.coSignerForm.state.disable() : this.coSignerForm.state.enable();
    }
}
